import React from 'react'
import Notice from 'components/CustomComponents/Notice'
import EmailVerificationNotice from 'components/CustomComponents/EmailVerificationNotice'
import Alert from 'antd/lib/alert'
import l8n from 'l8n'

import './style.scss'

class NotificationArea extends React.Component {
  render() {
    const { user } = this.props

    return (
      <div className="notification-area">
        { (! user.email_verified) &&
        <Alert
          className="notification"
          description={(<EmailVerificationNotice/>)}
          type="warning"
          showIcon
          closable
        /> }
        { user.show_message_fill_details || user.show_activation_message ?
          <Alert
            className="notification"
            message={l8n.p_activation}
            description={(<Notice/>)}
            type="warning"
            showIcon
          /> : null}
        { user.empty_talk_type ?
          <Alert
            className="notification"
            description={l8n.p_clients_havent_talk_status}
            type="warning"
            showIcon
          /> : null}
      </div>
    )
  }
}

export default NotificationArea



// WEBPACK FOOTER //
// ./src/components/CustomComponents/NotificationArea/index.js